import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,
    FormGroup,
    Label,
    Input,
    FormFeedback,
    Row,
    Col
} from 'reactstrap';

import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Isvg from 'react-inlinesvg';
import moveIcon from '../../../assets/svg/move.svg';
import moreIcon from '../../../assets/svg/more.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import xIcon from '../../../assets/svg/x.svg';
import noNotifications from '../../../assets/svg/no-notif.svg';

import notesIcon from '../../../assets/svg/notes-icon.svg';

import PatientNotesPreview from '../../../components/patientNotesPreview';


import moment from 'moment';
import { API_ENDPOINT, getAgeLimit, translateAgeLimitMessage } from '../../../constants';
import ErrorModal_v2 from '../../../components/errorModal_v2';
import CustomSelectWithSearch from '../../../components/forms/fields/customSelectWithSearch';
import Checkbox from '../../../components/forms/fields/checkbox';
import DatePicker from '../../../components/forms/fields/datePicker';
import TimePickerV2 from '../../../components/forms/fields/timepicker_v2';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import EventMeetingsModal from '../../../components/eventMeetingsModal';
import SelectWithCheckbox from '../../../components/forms/fields/selectWithCheckbox';
import { isStringAValidNumber } from '../../../components/TwoFactorAuthModal';
import ErrorModal from '../../../components/errorModal';

import striptags from 'striptags';
import DoctorListComponent from '../../../components/forms/fields/doctorListComponent';
import InfoModal from '../../../components/infoModal';
import PatientModal from './patientModal';
import AddSecondParentModal from '../../../components/addSecondParentModal';
import { addMinutesToTime } from '../helper';
import PaymentMethodsField from '../../payments/components/paymentMethodsField';
import { getExtendedPaymentManagement } from '../../payments/helper';

function isTimeValidString(timeString) {
    let valid = false;
    if (timeString?.length === 5) {
        const [hours, minutes] = timeString.split(":").map((x) => parseInt(x, 10));
        if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
            valid = true;
        }
    }


    return valid;
}


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
function truncateString(str) {
    if (str.length > 210) {
        return str.substring(0, 210) + '...';
    }
    return str;
}

class ScheduleAdministrativeBooking extends React.Component {

    constructor(props) {
        super(props);

        this.player = React.createRef();
        this.state = {
            ...props.initialData,
            doctors: [],
            languages: [],
            clinicians: [],
            minTime: '07:00',
            maxTime: '18:00',

        }
        this.state.min = new Date();
        this.state.min.setHours(7, 0, 0)
        this.state.max = new Date();
        this.state.max.setHours(18, 0, 0)

    }

    generateInitialTime = () => {
        let tsNow = Math.floor(new Date().getTime() / 1000);
        const interval = 10 * 60;
        const ts = Math.ceil(tsNow / interval) * interval;

        let date = moment.unix(ts).format(this.props.dateFormat);
        let startTime = moment.unix(ts).format('HH:mm');
        let endTime = moment.unix(ts + 60 * 5).format('HH:mm');

        let data = {
            date,
            endDate: date,
            startTime,
            endTime,
            title: ''
        }

        return data;
    }
    getDoctors = () => {
        let query = {
            // entries: 10,
            // page: 0,
            group: this.props.selectedGroup,
            clinic: this.props.selectedClinic,
            // doctor: this.state.doctorId,
            // filter: this.state.searchVisitReason ? this.state.searchVisitReason : this.state.selectRevisitForm ? this.state.searchRevisitForm : '',
            // day: this.state.day ? this.state.day : new Date(),
            // view: this.state.view
        };
        let queryFields = {};
        for (var key in query) {
            if (key && key.indexOf('query-') === 0) {
                queryFields[key.replace('query-', '')] = query[key];
            }
        }

        fetch(API_ENDPOINT + '/users/subaccounts/doctors', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                page: null,
                entries: null,
                filter: query.filter,
                sortType: query.sortType,
                sortField: query.sortField,
                groupId: query.group,
                clinic: query.clinic,
                query: queryFields
            })
        }).then(res => res.json()).then((result) => {
            if (result) {
                this.setState({ doctors: result })
            }
        })


    }
    getClinicians = () => {
        const clinicId = this.props.selectedClinic;
        if (!clinicId) return;

        this.setState({ clinicians: [] }, () => {
            fetch(API_ENDPOINT + `/data/calendar/doctors/${clinicId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.clinicians?.length) {
                    this.setState({ clinicians: result.clinicians });
                }
            })
        });
    }

    setInitialData = () => {
        const groupData = this.getGroupData();
        this.setState({ groupData: groupData });

        let data = this.props.isOpen;
        if (!data?.date || !data?.endDate || !data?.startTime || !data?.endTime) {
            let initialTime = this.generateInitialTime();
            data = {
                ...initialTime,
                ...data
            }
        }

        const doctorId = data?.doctorId ?? data?.doctor ?? null;
        this.setState({ data: data, doctorId }, () => {
            this.getDoctors();
            this.getClinicians();
            this.getLanguages();
            if (this.state.data?.patientData?._id) {
                this.patientAge(this.state.data.patientData._id)
            }

            if (this.props.preselectPatient?.socialSecurityNumber) {
                this.findPatient(this.props.preselectPatient?.socialSecurityNumber)
            }
        })

    }
    getLanguages = () => {

        fetch(API_ENDPOINT + '/languages', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                sortType: 1,
                sortField: 'key',
                query: {}
            })
        }).then(parseJSON).then(({ result, status }) => {
            if (result) {
                this.setState({ languages: result })
            }
        })

    }

    googleHolidayEvents = () => {
        const groupId = this.props.selectedGroup;
        if (!groupId) return;

        this.setState({ holidayEvents: [] }, () => {

            fetch(API_ENDPOINT + '/google/holidays/events/' + groupId, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
            }).then(res => res.json()).then((result) => {
                if (result?.items?.length) {
                    let holidayEvents = [...result.items]
                    for (let i = 0; i < holidayEvents.length; i++) {
                        if (holidayEvents[i].date) {
                            let _start = `${holidayEvents[i].date} 08:00`;
                            let _end = `${holidayEvents[i].date} 17:00`;
                            holidayEvents[i].startTime = Math.floor(new Date(_start).getTime() / 1000);
                            holidayEvents[i].endTime = Math.floor(new Date(_end).getTime() / 1000);
                        }
                    }
                    this.setState({ holidayEvents })
                }
            })
        })

    }

    componentDidMount() {

        this.setInitialData();
        this.googleHolidayEvents();

    }
    componentDidUpdate(prevProps, prevState) {


    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        let groupData = this.props?.uData?.clinicGroups?.[selectedGroupIdx];

        return groupData;
    }
    toggle = (toggle = true) => {
        this.setState({
            // age: null,
            // patient: null,
            // doctorsList: [],
            // revisitFormsSelected: [],
            // revisitFormsSelect: [],
            // journalNoteFormSelected: null
        }, () => {
            if (this.props.toggle) {
                this.props.toggle(toggle);
            }
        })

    }
    getWorkingHours = () => {
        const doctorId = this.state.doctorId;
        const clinicId = this.props.selectedClinic;
        const groupId = this.props.selectedGroup;

        if (!doctorId || !clinicId || !groupId) return;

        const obj = {
            clinicianId: doctorId,
            clinicId: clinicId,
            groupId: groupId
        };

        fetch(API_ENDPOINT + `/data/calendar/clinician/working-hours`, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(parseJSON).then(({ result, status }) => {

            let { minTime, maxTime } = result;
            if (!minTime) minTime = '07:00';
            if (!maxTime) maxTime = '18:00';

            let setObj = {};
            if (minTime !== this.state.minTime) {
                setObj.minTime = minTime;
            }
            if (maxTime !== this.state.maxTime) {
                setObj.maxTime = maxTime;
            }
            if (Object.keys(setObj).length > 0) {
                this.setState(setObj)
            }

        })
    }

    patientAge = (data, callback) => {

        let country = this.state.countryStateDict?.['search-ssn'] ?? this.props.country;

        fetch(API_ENDPOINT + '/users/users/get-age/' + data, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                socialSecurityNumber: this.state.patientSocialSecurityNumber,
                country
            })
        }).then(res => res.json()).then((result) => {
            this.setState({
                age: result.age
            }, () => {
                if (callback) {
                    callback();
                }
            })
        })
    }
    checkSSN = (ssn) => {
        fetch(API_ENDPOINT + '/users/patient/check/ssn', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                group: this.props.selectedGroup,
                clinic: this.props.selectedClinic,
                socialSecurityNumber: ssn
            })
        }).then(res => res.json()).then((result) => {
            if (result) {
                this.setState({ socialSecurityNumberExist: result.exist, ssnExistInThisGroup: result.ssnExistInThisGroup, needsParent: result.needsParent, hasParent: result.hasParent }, () => {
                    const _ageLimitFix = this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup && this.state.needsParent && !this.state.hasParent ? true : false;
                    if (this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup) {
                        fetch(API_ENDPOINT + '/users/subaccounts/get', {
                            method: 'POST',
                            headers: {
                                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                                'content-type': 'application/json'
                            },
                            body: JSON.stringify({ socialSecurityNumber: ssn, group: this.props.selectedGroup, clinic: this.props.selectedClinic })
                        }).then(parseJSON).then(({ result, status }) => {
                            if (status == 200 && result && result.userData) {

                                this.props.changeName(result.userData.name);
                                this.props.changeSex(result.userData.sex);
                                if (!_ageLimitFix) this.props.changeEmail(result.email)
                                if (!_ageLimitFix) this.props.changePhone(result.phone)

                                if (result.parentObj) {
                                    this.props.changeSocialSecurityNumberParent(result.parentObj.socialSecurityNumber)
                                    this.props.changeNameParent(result.parentObj.name);
                                    this.props.changeEmail(result.parentObj.email);
                                    if (result.parentObj.userData.sex)
                                        this.props.changeSexParent(result.parentObj.userData.sex);
                                    this.props.changeLanguage(result.parentObj.language);
                                    this.props.changePhone(result.parentObj.phone);
                                }

                            }
                        })
                    }
                })
            }

        })
    }
    findPatient = (ssn) => {
        if (!ssn) {
            if (this.state.patientSocialSecurityNumber) {
                ssn = this.state.patientSocialSecurityNumber;
            } else {
                return;
            }
        }

        if (ssn) {
            this.checkSSN(ssn)
        }

        this.setState({ patient: null, age: null }, () => {
            fetch(API_ENDPOINT + '/users/find/patient', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    group: this.props.selectedGroup,
                    clinic: this.props.selectedClinic,
                    socialSecurityNumber: ssn
                })
            }).then(res => res.json()).then((result) => {
                //result = result?.error ? result?.error : result?.length ? result[0] : null;
                if (result.error) {
                    this.setState({
                        error: result.error.translate(this.props.lang),
                        loading: false
                    })
                } else {
                    if (result && result.name && result.socialSecurityNumber) {
                        let data = this.state.data;
                        data.patientData = result;

                        this.setState({
                            data
                        }, () => {
                            if (this.state.data?.patientData?._id) {
                                this.patientAge(this.state.data.patientData._id)
                            }

                            if (this.props.preselectPatient) {
                                let data = this.state.data ?? {};
                                data.title = result?.userData?.name?.trim();
                                data.socialSecurityNumber = result.socialSecurityNumber;
                                data.patient = result._id;
                            }
                        })
                    } else {
                        const groupData = this.getGroupData();

                        let enterprise = groupData.enterprise;
                        let canSearchPatients = groupData.sarchPatients;

                        if (enterprise || canSearchPatients) {
                            this.setState({
                                errorPatientNotFound: 'Check digits or register a new patient'.translate(this.props.lang)
                            }, () => {
                                this.patientAge(ssn)
                            })
                        } else {
                            this.setState({
                                error: 'The patient you are searching can not be found in your clinic'.translate(this.props.lang)
                            })
                        }

                    }

                }

            })
        })

    }
    checkDoctorsAvailable = (doctorsList, modal, callback) => {
        let event;
        event = this.state.data;

        if (doctorsList) {
            let data = {
                doctorsList: doctorsList,
                startEventReservedDateOriginal: event.date + ' ' + event.startTime,
                endEventReservedDateOriginal: event.date + ' ' + event.endTime,
                startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(event.date + ' ' + event.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(event.date + ' ' + event.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                eventId: event.id
            }
            fetch(API_ENDPOINT + '/working-hours/check/doctors', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        errorAdditionalDoctors: result.doctorsList
                    })
                } else {
                    this.setState({ doctorsModal: false, successfullyAdditionalDoctors: modal != 4 ? true : false }, () => {

                        let data = this.state.data;
                        data.additionalDoctors = this.state.doctorsList;
                        this.setState({ data })


                    })
                }
                if (callback) {
                    callback();
                }


            })
        }


    }
    setData = (data, callback) => {
        this.setState({ data }, () => {
            if (callback) {
                callback();
            }
        })
    }
    scheduleAdministrativeBooking = (forceInsert = false) => {
        const data = this.state.data;
        const _data = JSON.parse(JSON.stringify(data));
        if (!_data) {
            this.setState({ creatingEvent: false });
            return;
        }

        let checkDate = new Date(data?.date?.replace(/-/g, "/") + ' ' + data?.startTime);
        let today = new Date();

        if (checkDate < today && !forceInsert) {
            this.setState({
                wrongDateModal: true
            })
            return;
        } else {
            if (this.state.wrongDateModal) {
                this.setState({ wrongDateModal: null });
            }
        }

        let dataToSend = {
            startEventReservedDateOriginal: data.date + ' ' + data.startTime,
            endEventReservedDateOriginal: data.date + ' ' + data.endTime,
            startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
            endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
            title: data.title,
            socialSecurityNumber: data.socialSecurityNumber,
            patientId: data?.patientData?._id || null,
            doctor: this.state.doctorId,
            group: this.props.selectedGroup,
            clinic: this.props.selectedClinic,
            patientNote: data.patientNote,
            additionalDoctors: data.additionalDoctors,
            titleDoctor: data.titleDoctor,
            selectedParents: data.selectedParents,
            guests: data.guests,
        };

        this.setState({ loading: true }, () => {
            fetch(API_ENDPOINT + '/data/calendar/administrative-bookings/schedule', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(dataToSend)
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        error: result.error.translate(this.props.lang),
                        loading: false,
                        creatingEvent: false
                    })
                } else {
                    this.setState({
                        creatingEvent: false,
                        loading: false,
                    });

                    this.toggle();
                }


            })
        });


    }
    render() {
        const isOpen = this.props.isOpen ? true : false;
        if (!isOpen || !this.state.data) return null;

        const groupData = this.state.groupData;
        const enterprise = groupData?.enterprise;
        const eventMeetings = groupData?.eventMeetings ?? false;

        const AGE_LIMIT = getAgeLimit(this.props.country, this.props.selectedGroup, this.props.clinicsAgeLimitExceptions);
        const isChild = typeof this.state.age === 'number' && this.state.age < AGE_LIMIT ? true : false;

        const msg = translateAgeLimitMessage(
            "Child is under {AGE_LIMIT} years of age - Account must be connected to a parent- or legal guardian account.",
            this.props.lang,
            AGE_LIMIT
        );
        const msg2 = translateAgeLimitMessage(
            "Child is under {AGE_LIMIT} years of age - Appointments are handled by parent or legal guardian.",
            this.props.lang,
            AGE_LIMIT
        );


        const patientData = this.state.data?.patientData ?? null;

        const doctorId = this.state.doctorId ?? null;
        const disabledDoctorSelect = this.props.isOpen?.doctorId && this.props.isOpen?.disabledDoctorSelect !== false ? true : false;

        const { minTime, maxTime } = this.state;

        const titleTooltipText = 'Administrative bookings are never seen by the patient. Colleagues can chat/video without the patient. External guests can be invited to video without the patient.'.translate(this.props.lang);

        return (
            <>

                <Modal isOpen={isOpen} centered>
                    <ModalHeader
                        toggle={() => this.toggle()}
                        close={
                            <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.toggle()}>&times;</button>
                        }
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                            {'Schedule administrative booking'.translate(this.props.lang)}
                            <div className="parent-tooltip update-administrative-booking-tooltip">
                                <Isvg src={infoIcon} className="info-text" />
                                <div className="chat-icons-tooltip">
                                    {titleTooltipText}
                                </div>
                            </div>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        {
                            !disabledDoctorSelect ?
                                <FormGroup>
                                    <Label>{'Doctor'.translate(this.props.lang) + '*'}</Label>
                                    <Input
                                        type='select'
                                        value={doctorId}
                                        disabled={disabledDoctorSelect}
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            if (value === '-1') value = null;
                                            this.setState({ doctorId: value }, () => {
                                                this.getWorkingHours();
                                                let data = this.state.data;
                                                if (this.state.doctorId && data?.additionalDoctors?.find(el => el === this.state.doctorId)) {
                                                    data.additionalDoctors = data.additionalDoctors.filter(el => el !== this.state.doctorId);
                                                    this.setData(data);
                                                }
                                                if (this.state.doctorId && this.state.doctorsList?.find(el => el === this.state.doctorId)) {
                                                    let doctorsList = this.state.doctorsList;
                                                    doctorsList = doctorsList.filter(el => el !== this.state.doctorId);
                                                    this.setState({ doctorsList })
                                                }
                                            })

                                        }}
                                    >
                                        <option value={'-1'}>{'Select doctor'.translate(this.props.lang)}</option>
                                        {
                                            this.state.clinicians.map((item, idx) => {
                                                return (
                                                    <option value={item._id} key={idx}>{item.name}</option>
                                                )
                                            })
                                        }
                                    </Input>
                                </FormGroup>
                                :
                                null
                        }
                        <div className='schedule-control-find-patient-wrap'>

                            {
                                this.props.preselectPatient && this.props.preselectPatient != '' ?
                                    null :
                                    <FormGroup>
                                        <Button
                                            color='primary'
                                            onClick={() => {
                                                if (this.props.findPatient) {
                                                    this.props.findPatient({ ...this.state.data, doctor: this.state.doctorId, disabledDoctorSelect: disabledDoctorSelect }, null)
                                                }
                                            }}
                                        >
                                            {'Find patient'.translate(this.props.lang)}
                                        </Button>
                                    </FormGroup>
                            }

                        </div>

                        {
                            isChild ?
                                <FormGroup>
                                    <Label style={{ color: 'red' }}>{msg2}</Label>
                                </FormGroup>
                                :
                                null
                        }
                        {
                            isChild ?
                                <FormGroup>
                                    <Label style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{"Parent/legal guardian added to appointment".translate(this.props.lang)} <div className="parent-tooltip"> <Isvg src={infoIcon} className="info-text" /> <div className="chat-icons-tooltip">{'Appointment can be managed by one or two parents/legal guardians. Selected persons will receive notification and can participate in chat and videocalls'.translate(this.props.lang)}</div> </div></Label>
                                    {
                                        patientData?.parentObj?.socialSecurityNumber && patientData?.parentObj2?.socialSecurityNumber ?
                                            <div className='table-parents-wrap'>
                                                <table className='table-parents'>
                                                    <tr>
                                                        <td>
                                                            <Checkbox
                                                                checked={this.state.data?.selectedParents?.indexOf(patientData?.parentObj?._id) !== -1 ? true : false} onChange={(e) => {
                                                                    let data = this.state.data;
                                                                    let selectedParents = data.selectedParents ?? [];
                                                                    let parentId;
                                                                    if (patientData?.parentObj?._id) {
                                                                        parentId = patientData.parentObj._id;
                                                                    }
                                                                    if (e.target.checked) {
                                                                        if (parentId && selectedParents.indexOf(parentId) === -1) {
                                                                            selectedParents.push(parentId)
                                                                        }
                                                                    } else {
                                                                        if (parentId && selectedParents.indexOf(parentId) !== -1 && selectedParents.length > 1) {
                                                                            let index = selectedParents.indexOf(parentId);
                                                                            selectedParents.splice(index, 1)
                                                                        }
                                                                    }
                                                                    data.selectedParents = selectedParents;
                                                                    let parents = [];

                                                                    for (let i = 0; i < selectedParents.length; i++) {
                                                                        if (patientData?.parentObj?._id === selectedParents[i] && patientData?.parentObj?.name) {
                                                                            parents.push(patientData.parentObj.name.trim())
                                                                        }
                                                                        if (patientData?.parentObj2?._id === selectedParents[i] && patientData?.parentObj2?.name) {
                                                                            parents.push(patientData.parentObj2.name.trim())
                                                                        }
                                                                    }

                                                                    data.title = patientData.userData.name.trim() + ' ' + 'Parent/legal guardian:'.translate(this.props.lang) + ` ${parents.join(', ')}`;

                                                                    this.setState({ data })

                                                                }} />
                                                        </td>
                                                        <td>{patientData && patientData.parentObj && patientData.parentObj.name}</td>
                                                        <td>{patientData && patientData.parentObj && patientData.parentObj.socialSecurityNumber}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Checkbox
                                                                checked={this.state.data?.selectedParents?.indexOf(patientData?.parentObj2?._id) !== -1 ? true : false} onChange={(e) => {
                                                                    let data = this.state.data;
                                                                    let selectedParents = data.selectedParents ?? [];
                                                                    let parentId;
                                                                    if (patientData?.parentObj2?._id) {
                                                                        parentId = patientData.parentObj2._id;
                                                                    }
                                                                    if (e.target.checked) {
                                                                        if (parentId && selectedParents.indexOf(parentId) === -1) {
                                                                            selectedParents.push(parentId)
                                                                        }
                                                                    } else {
                                                                        if (parentId && selectedParents.indexOf(parentId) !== -1 && selectedParents.length > 1) {
                                                                            let index = selectedParents.indexOf(parentId);
                                                                            selectedParents.splice(index, 1)
                                                                        }
                                                                    }
                                                                    data.selectedParents = selectedParents;
                                                                    let parents = [];

                                                                    for (let i = 0; i < selectedParents.length; i++) {
                                                                        if (patientData?.parentObj?._id === selectedParents[i] && patientData?.parentObj?.name) {
                                                                            parents.push(patientData.parentObj.name.trim())
                                                                        }
                                                                        if (patientData?.parentObj2?._id === selectedParents[i] && patientData?.parentObj2?.name) {
                                                                            parents.push(patientData.parentObj2.name.trim())
                                                                        }
                                                                    }

                                                                    data.title = patientData.userData.name.trim() + ' ' + 'Parent/legal guardian:'.translate(this.props.lang) + ` ${parents.join(', ')}`;


                                                                    this.setState({ data })
                                                                }} />
                                                        </td>
                                                        <td>{patientData && patientData.parentObj2 && patientData.parentObj2.name}</td>
                                                        <td>{patientData && patientData.parentObj2 && patientData.parentObj2.socialSecurityNumber}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                            :
                                            <div>
                                                <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
                                                    <p>{patientData && patientData.parentObj && patientData.parentObj.name}</p>
                                                    <p>{patientData && patientData.parentObj && patientData.parentObj.socialSecurityNumber}</p>
                                                </div>
                                                <div className='add-second-guardian-btn'>
                                                    <Button color='primary' onClick={() => {
                                                        let patientObj = JSON.parse(JSON.stringify(patientData))
                                                        this.setState({ addSecondGuardian: patientObj })
                                                    }}>{'Add second parent/legal guardian'.translate(this.props.lang)}</Button>
                                                </div>
                                            </div>
                                    }


                                </FormGroup>
                                :
                                null
                        }
                        {
                            isChild && this.state.data && this.state.data.title ?
                                <FormGroup>
                                    <div className='patient-no-notif-modal'>
                                        <Label>{'Title'.translate(this.props.lang)}</Label>
                                        {
                                            !patientData?.phone && !patientData?.email ?
                                                <div className='patient-no-notif'>
                                                    <Isvg src={noNotifications} width={20} height={20} />
                                                    <div>
                                                        {'Phone and email not registered'.translate(this.props.lang)}
                                                    </div>
                                                    <div className='tooltip-text'>{'No contact details registered. Add information in the patient profile to send notifications.'.translate(this.props.lang)}</div>
                                                </div>
                                                :
                                                null
                                        }
                                    </div>

                                    <Input
                                        disabled
                                        type='textarea'
                                        value={this.state.data.titleDoctor && this.state.data.titleDoctor != '' ?
                                            `Patient: ${this.state.data.title}, ${this.state.doctorId ? this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.userData?.title && this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.userData.name ? `${this.props.formatName(this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.userData.title, this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.userData.name)}` : this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.name : this.props.uData.name}, ${this.state.data.visitReasonName && this.state.data.visitReasonName != '' ? ', (' + this.state.data.visitReasonName + ')' : ''}` + ', ' + this.state.data.titleDoctor :
                                            `Patient: ${this.state.data.title}, ${this.state.doctorId ? this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.userData?.title && this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.userData.name ? `${this.props.formatName(this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.userData.title, this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.userData.name)}` : this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.name : this.props.uData.name}, ${this.state.data.visitReasonName && this.state.data.visitReasonName != '' ? ', (' + this.state.data.visitReasonName + ')' : ''}`} />

                                    <Input type='text' style={{ marginTop: 5 }}
                                        onChange={(e) => {
                                            let data = this.state.data;
                                            data.titleDoctor = striptags(e.target.value);
                                            this.setState({
                                                data
                                            })
                                        }}
                                        value={this.state.data.titleDoctor}
                                    />

                                </FormGroup>

                                :

                                this.state.data && this.state.data.title ?
                                    <FormGroup>
                                        <div className='patient-no-notif-modal'>
                                            <Label>{'Title'.translate(this.props.lang)}</Label>
                                            {
                                                !patientData?.phone && !patientData?.email ?
                                                    <div className='patient-no-notif'>
                                                        <Isvg src={noNotifications} width={20} height={20} />
                                                        <div>
                                                            {'Phone and email not registered'.translate(this.props.lang)}
                                                        </div>
                                                        <div className='tooltip-text'>{'No contact details registered. Add information in the patient profile to send notifications.'.translate(this.props.lang)}</div>
                                                    </div>
                                                    :
                                                    null
                                            }
                                        </div>

                                        <Input
                                            disabled
                                            type='textarea'
                                            value={
                                                this.state.data.titleDoctor && this.state.data.titleDoctor != '' ?
                                                    `Patient: ${this.state.data.title}, ${this.state.doctorId ? this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.userData?.title && this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.userData.name ? `${this.props.formatName(this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.userData.title, this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.userData.name)}` : this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.name : this.props.uData.name}${this.state.data.visitReasonName && this.state.data.visitReasonName != '' ?
                                                        ', (' + this.state.data.visitReasonName + ')' : ''}` + ', ' + this.state.data.titleDoctor
                                                    :
                                                    `Patient: ${this.state.data.title}, ${this.state.doctorId ? this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.userData?.title && this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.userData.name ? `${this.props.formatName(this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.userData.title, this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.userData.name)}` : this.state.doctors.filter(item => item._id === this.state.doctorId)[0]?.name : this.props.uData.name}${this.state.data.visitReasonName && this.state.data.visitReasonName != '' ?
                                                        ', (' + this.state.data.visitReasonName + ')' : ''}`
                                            }
                                        />
                                        <Input
                                            type='text'
                                            style={{ marginTop: 5 }}
                                            onChange={(e) => {
                                                let data = this.state.data;
                                                data.titleDoctor = striptags(e.target.value);
                                                this.setState({
                                                    data
                                                })
                                            }}
                                            value={this.state.data.titleDoctor}
                                        />

                                    </FormGroup>
                                    :
                                    null

                        }

                        <DatePicker
                            label={'Date'.translate(this.props.lang)}
                            value={this.state.data.date}
                            holidayEvents={this.state.holidayEvents}
                            onChange={(e) => {
                                let data = this.state.data;
                                data.date = e;
                                this.setState({
                                    data
                                })
                                if (Math.floor(new Date(this.state.data.date + ' ' + this.state.data.startTime) / 1000) > Math.floor(new Date(this.state.data.endDate + ' ' + this.state.data.endTime) / 1000)) {
                                    data.endDate = this.state.data.date
                                    this.setState({
                                        data
                                    })
                                }
                            }}
                        />
                        <div className={this.state.data?.templateData?.selectedAvailabilityTemplate?._id ? 'schedule-control-time-wrap-template' : ''}>
                            <FormGroup className="timepicker-container timepicker-wide">
                                <Label>{'Start time'.translate(this.props.lang)}</Label>
                                &nbsp;
                                <TimePickerV2
                                    getStringDateTs={this.props.getStringDateTs}
                                    format={'HH:mm'}
                                    value={this.state.data.startTime}
                                    minValue={minTime}
                                    maxValue={addMinutesToTime(maxTime, -5)}
                                    flag={0}
                                    onChange={(time1, timeString) => {

                                        let data = this.state.data;
                                        data.startTime = timeString


                                        let startTimeSplit = data.startTime.split(":");
                                        let endTimeSplit = data.endTime.split(":");

                                        let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                        let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                        if (startTimeHourMinute < endTimeHourMinute) {
                                            this.setState({ data })
                                        } else {
                                            data.endTime = Math.trunc((Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) % 60
                                            const padded = data?.endTime?.split?.(':');
                                            if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                const h = padded[0]?.padStart?.(2, '0');
                                                const m = padded[1]?.padStart?.(2, '0');
                                                if (h && m) data.endTime = `${h}:${m}`;
                                            }
                                            this.setState({
                                                data
                                            })
                                        }
                                    }}
                                />
                            </FormGroup>
                            <FormGroup className="timepicker-container timepicker-wide">
                                <Label>{'End time'.translate(this.props.lang)}</Label>
                                &nbsp;
                                <TimePickerV2
                                    getStringDateTs={this.props.getStringDateTs}
                                    format={'HH:mm'}
                                    value={this.state.data.endTime}
                                    minValue={Math.trunc((Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) % 60}
                                    maxValue={maxTime}
                                    flag={0}
                                    onChange={(time1, timeString) => {

                                        let data = this.state.data;
                                        data.endTime = timeString

                                        let startTimeSplit = data.startTime.split(":");
                                        let endTimeSplit = data.endTime.split(":");

                                        let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                        let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                        if (startTimeHourMinute < endTimeHourMinute) {
                                            this.setState({ data })
                                        }
                                    }}
                                />

                            </FormGroup>
                        </div>
                        {
                            this.state.data.title ?
                                <FormGroup>
                                    <Label className='note-label-wrap'>{'Note'.translate(this.props.lang)}
                                        {/* <div className={this.state.patientNotes?.length ? 'notes-icon-wrap notes-icon-active' : 'notes-icon-wrap'} onClick={() => { this.setState({ showPatientNotes: true }) }}>
                                            <Isvg src={notesIcon} />
                                            <div className='tooltip-text'>{'Notes available'.translate(this.props.lang)}</div>
                                        </div> */}
                                    </Label>
                                    <Input type='textarea'
                                        name="note"
                                        style={{ height: '150px' }}
                                        onChange={(e) => {
                                            let data = this.state.data;
                                            data.patientNote = striptags(e.target.value);
                                            this.setState({
                                                data
                                            })
                                        }}
                                        value={this.state.data.patientNote}
                                    />
                                </FormGroup>
                                :
                                null
                        }
                        <div className='calendar-modal-buttons-wrap'>
                            {
                                this.state.data.title ?
                                    <FormGroup>
                                        <Button onClick={() => this.setState({
                                            doctorsModal: 3
                                        })} color="primary">
                                            {'Add caregiver'.translate(this.props.lang)}
                                        </Button>
                                    </FormGroup>
                                    :
                                    null
                            }
                            {
                                this.state.data.title && eventMeetings ?
                                    <FormGroup>
                                        <Button
                                            onClick={() => {
                                                let guests = [];
                                                if (this.state.data?.guests) {
                                                    guests = [...this.state.data.guests];
                                                }
                                                this.setState({
                                                    eventMeetingsModal: { ...this.state.data, guests, modal: 'administrativeBooking' }
                                                })
                                            }}
                                            color="primary"
                                        >
                                            {'Add guest'.translate(this.props.lang)}
                                        </Button>
                                    </FormGroup>

                                    :

                                    null
                            }
                        </div>


                        <Button
                            color='primary'
                            disabled={this.state.data.title && !this.state.creatingEvent && this.state.doctorId ? false : true}
                            onClick={() => this.setState({
                                creatingEvent: true
                            }, () => {
                                this.scheduleAdministrativeBooking();
                            })}
                        >
                            {'Schedule administrative booking'.translate(this.props.lang)}
                        </Button>


                    </ModalBody>
                </Modal>
                {
                    this.state.eventMeetingsModal ?
                        <EventMeetingsModal
                            {...this.props}
                            data={this.state.eventMeetingsModal}
                            doctorId={this.state.doctorId}
                            onClose={() => this.setState({ eventMeetingsModal: null })}
                            closeButtonText={'Close without saving'.translate(this.props.lang)}
                            saveData={(data) => {
                                let setObj = { eventMeetingsModal: null };
                                let modal = this.state.eventMeetingsModal?.modal;
                                console.log('saving event meetings data:', data, modal);
                                if (data && modal) {
                                    if (modal === 'administrativeBooking') {
                                        let eventObj = this.state.data;
                                        eventObj.guests = data;
                                        this.setData(eventObj)
                                    }
                                }
                                this.setState(setObj)
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.successfullyAdditionalDoctors ?
                        <InfoModal
                            isOpen={this.state.successfullyAdditionalDoctors}
                            toggle={() => this.setState({ successfullyAdditionalDoctors: !this.state.successfullyAdditionalDoctors })}
                            header={'Info'.translate(this.props.lang)}
                            info={`All doctors were successfully added`.translate(this.props.lang)}
                            buttons={[
                                <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ successfullyAdditionalDoctors: false })}>{'Ok'.translate(this.props.lang)}</Button>,

                            ]}

                        />
                        :
                        null
                }
                {
                    this.state.doctorsModal ?
                        <Modal isOpen={this.state.doctorsModal} centered toggle={() => this.setState({ doctorsModal: !this.state.doctorsModal })} >
                            <ModalHeader toggle={() => this.setState({ doctorsModal: !this.state.doctorsModal })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ doctorsModal: !this.state.doctorsModal })}><Isvg src={xIcon} /></button>}>{'Choose doctors'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody className="run-modal">

                                {
                                    this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                        if (item._id != this.state.doctorId) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    }).length ?
                                        <FormGroup >
                                            <Label>{'Search'.translate(this.props.lang)}</Label>
                                            <Input type='text' value={this.state.filterDoctors ? this.state.filterDoctors : ''} onChange={(e) => {
                                                this.setState({
                                                    filterDoctors: e.target.value
                                                })
                                            }} />

                                        </FormGroup>
                                        :
                                        null
                                }

                                <FormGroup >
                                    {
                                        this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                            if (item._id != this.state.doctorId) {
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        }).length ?
                                            <DoctorListComponent

                                                value={this.state.doctorsList ? this.state.doctorsList : []}
                                                values={this.state.doctors.filter(el =>
                                                    (!this.state.updateEvent || (this.state.updateEvent && this.state.updateEvent.patientId != el._id))
                                                    && (!this.state.scheduleReferral || (this.state.scheduleReferral && this.state.referralId && this.state.referrals.filter(ref => ref._id == this.state.referralId) && this.state.referrals.filter(ref => ref._id == this.state.referralId)[0] && this.state.referrals.filter(ref => ref._id == this.state.referralId)[0].patientId != el._id))
                                                    && (!this.state.data || (this.state.data && this.state.data.patient != el._id))
                                                ).sort((a, b) => {
                                                    const nameA = a.name;
                                                    const nameB = b.name;
                                                    if (nameA < nameB) {
                                                        return -1
                                                    }
                                                    if (nameA > nameB) {
                                                        return 1
                                                    }
                                                }).filter(doc => doc._id !== this.state.doctorId && doc.name.toLowerCase().indexOf(this.state.filterDoctors ? this.state.filterDoctors.toLowerCase() : ' ') != -1).map(item => {
                                                    return ({
                                                        name: item.name,
                                                        value: item._id,
                                                        profilePicture: item.profilePicture,
                                                        username: item.username
                                                    })
                                                })}
                                                onChange={(item) => {
                                                    let doctorsList = this.state.doctorsList;
                                                    doctorsList = [...item]
                                                    this.setState({ doctorsList })
                                                }}
                                            />

                                            :
                                            "The doctor's list is empty".translate(this.props.lang)
                                    }
                                </FormGroup>


                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                {
                                    this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                        if (item._id != this.state.doctorId) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    }).length ?
                                        <Button color='primary'
                                            onClick={() =>
                                                this.checkDoctorsAvailable(this.state.doctorsList, this.state.doctorsModal)
                                            }>{'Add'.translate(this.props.lang)}</Button>
                                        :
                                        null
                                }
                                <Button color='primary' onClick={() => {
                                    this.setState({ doctorsModal: false })
                                }
                                }>{"Close".translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.error ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}
                        >
                            {this.state.error}
                        </ErrorModal>

                        :
                        null
                }
                {
                    this.state.wrongDate ?
                        <Modal isOpen={this.state.wrongDate} centered>
                            <ModalBody className="delete-modal">
                                <p className='message'>{'You can not pick date form the past'.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className="buttons-right-blue">
                                <Button style={{ minWidth: 100 }} color='primary' onClick={() => this.setState({ wrongDate: !this.state.wrongDate })}>{'Pick again'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        : null
                }

                {
                    this.state.addSecondGuardian ?
                        <AddSecondParentModal
                            {...this.props}
                            languages={this.state.languages}
                            data={this.state.addSecondGuardian}
                            close={(getPatientData) => this.setState({ addSecondGuardian: null }, () => {
                                if (getPatientData) {
                                    let ssn = patientData?.socialSecurityNumber;
                                    this.findPatient(ssn)
                                }
                            })}
                        />
                        :
                        null
                }
                {
                    this.state.errorAdditionalDoctors ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.errorAdditionalDoctors}
                            toggle={() => {

                                this.setState({ errorAdditionalDoctors: null })
                            }}

                        >
                            {
                                this.state.errorAdditionalDoctors && this.state.errorAdditionalDoctors.map((item, idx) => {
                                    return (
                                        <div>
                                            <span style={{ fontWeight: 600 }}>
                                                {item.doctorName}  {' - '}
                                            </span>

                                            {
                                                item.available ?
                                                    <span style={{ color: 'green' }}>{'Available'.translate(this.props.lang)}</span>
                                                    :
                                                    <span style={{ color: 'red' }}>{'Unavailable'.translate(this.props.lang)}</span>
                                            }

                                        </div>
                                    )
                                })

                            }
                        </ErrorModal>
                        :
                        null
                }
                {
                    this.state.wrongDateModal ?
                        <InfoModal
                            isOpen={this.state.wrongDateModal}
                            onClose={(item) => {
                                this.setState({
                                    wrongDateModal: null
                                })
                            }}
                            info={"This event has already occurred.".translate(this.props.lang)}
                            buttons={[
                                <Button
                                    // color='success'
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => {
                                        this.scheduleAdministrativeBooking(true);
                                    }}
                                >
                                    {"Save".translate(this.props.lang)}
                                </Button>,
                                <Button
                                    // color='danger'
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => {
                                        this.setState({
                                            wrongDateModal: null,
                                            creatingEvent: null,
                                        })
                                    }}
                                >
                                    {'Go back'.translate(this.props.lang)}
                                </Button>,
                            ]}
                        />
                        :
                        null
                }


            </>


        )
    }
}

export default ScheduleAdministrativeBooking;